<template>
  <div class="protocol-container">
    <GoBack v-if="!isElectron" />
    <div class="agreement-content">
      <h1 class="page-title">拼团规则</h1>
      <h2>什么是拼团？</h2>
      <p>
        拼团是一种多人组团购买同个商品、借此以低于正常原价购得商品的活动。当平台的课程有拼团活动时，在课程的商品详情页开团入口下单并进行付款即可开启拼团。
        每个拼团订单会有一个有效期，在有效期内若参团人数达到设定的拼团人数则拼团成功，反之则拼团失败。拼团失败的订单系统将自动退款。
      </p>
      <h2>如何参与拼团？</h2>
      <p>
        当课程存在未拼满的拼团时，在商品详情页会展示可参与的团，登录后点击“去参团”按钮并完成支付，一旦达到拼团人数要求，则算拼团报名课程成功。
      </p>
      <h2>什么是团长？</h2>
      <p>
        团长是首位参与课程拼团活动下单且成功完成支付的人，即团长是拼团订单的发起者。
      </p>
      <h2>如何邀请好友参团？</h2>
      <p>
        完成拼团支付后，您在拼团相关页面可以点击“转发拼团”按钮将链接复制到粘贴板，再选择通讯产品将内容粘贴发给好友即可实现邀请好友参团。
      </p>
      <h2>如何算拼团成功？</h2>
      <p>
        在拼团订单的有效期内，成功找到满足拼团要求人数的学员并完成支付，即算作拼团成功。拼团的进度可在交易页面进行查询。
      </p>
      <h2>拼团失败，如何退款？</h2>
      <p>
        当拼团订单超过有效期或机构结束拼团活动时，若参团人数仍未达到拼团要求人数，将算作拼团失败。系统会自动为失败的拼团订单办理退款，无需麻烦学员手动操作，支付的款项会原路返回，具体到账时间以各银行规定为准。
      </p>
    </div>
  </div>
</template>

<script>
import { GoBack } from "@saas/components/src";
export default {
  data: function () {
    return {
      isElectron: window.isElectron,
    };
  },
  components: {
    GoBack,
  },
};
</script>

<style scoped src="../../assets/css/zx-agreement.css"></style>

<style scoped>
.protocol-container {
  min-height: 100vh;
}
.protocol-container .page-title {
  margin: 10px 0 40px;
}
</style>
